import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
  inject,
  makeStateKey,
  signal,
} from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { NotificationService } from '../../shared/components/notification/notification.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { EXPRESS_HOST, SERVER_COOKIES } from '../../app.module';
import { TransferState } from '@angular/platform-browser';
import { AuthService } from '@core/services/authentication/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingService } from '@shared/services/loading.service';

@Injectable()
export class GlobalHttpErrorHandler implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loadingService: LoadingService,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject(SERVER_COOKIES) private rawHeaders: string[],
    @Optional() @Inject(EXPRESS_HOST) baseUrl?: string
  ) {
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(this.expressUrl, baseUrl);
    } else baseUrl = this.transferState.get(this.expressUrl, '');

    this.baseUrl = baseUrl ?? '';
  }

  router = inject(Router);
  route = inject(ActivatedRoute);
  private notif = inject(NotificationService);
  transferState: TransferState = inject(TransferState);
  headers = makeStateKey<string[]>('headers');
  expressUrl = makeStateKey<string>('expressUrl');
  interceptedFirstRequest = signal(false);
  routeValidation = makeStateKey<boolean>('routeValidation');
  baseUrl: string;
  createCookies(cookieIndex: any, refererIndex: any): any {
    const headers: any = {};
    headers['x-service-agent'] = 'website';
    if (this.rawHeaders) {
      this.rawHeaders?.[cookieIndex + 1]?.split(';').forEach((header, index) => {
        headers[header?.split('=')[0].trimStart()] = header?.split('=')[1];
      });
    }

    return headers;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isPlatformServer(this.platformId)) {
      let newHeaders: any;
      let newCookies: any;
      let newReferer: any;
      if (this.rawHeaders.length) {
        this.transferState.set(this.headers, this.rawHeaders);
        const cookieIndex =
          this.rawHeaders?.indexOf('Cookie') == -1
            ? this.rawHeaders?.indexOf('cookie')
            : this.rawHeaders?.indexOf('Cookie');
        const refererIndex =
          this.rawHeaders?.indexOf('Referer') == -1
            ? this.rawHeaders?.indexOf('referer')
            : this.rawHeaders?.indexOf('Referer');

        newCookies = this.rawHeaders[cookieIndex + 1];
        newReferer = this.rawHeaders[refererIndex + 1]?.includes('http')
          ? this.rawHeaders?.[refererIndex + 1]
          : '';

        newHeaders = new HttpHeaders({
          Cookie: this.rawHeaders[cookieIndex + 1],
          Referer: this.rawHeaders[refererIndex + 1]?.includes('http')
            ? this.rawHeaders?.[refererIndex + 1]
            : '',
        });

        newHeaders.set('Cookie', this.rawHeaders[cookieIndex + 1]);
        newHeaders.set(
          'Referer',
          this.rawHeaders?.[refererIndex + 1]?.includes('http')
            ? this.rawHeaders?.[refererIndex + 1]
            : ''
        );
      }

      const newRequest = request.clone({
        headers: request.headers,
        //  .set('Cookie', newCookies)
        //  .set('Referer', newReferer),
        // withCredentials: true,
      });
      return next.handle(newRequest).pipe(
        tap((response) => {
          this.interceptedFirstRequest.set(true);
          const activatedRoute = this.router.routerState.snapshot.url;
          let isRouteValid;
          let routeHasUppercase;
          if (activatedRoute && activatedRoute.split('/').length > 2) {
            isRouteValid =
              activatedRoute.toLocaleLowerCase().includes('ecolodge') ||
              activatedRoute
                .toLocaleLowerCase()
                .split('/')[1]
                .split('-')
                .some((e) => e == 'hotels') ||
              activatedRoute.toLocaleLowerCase().includes('search') ||
              this.route.snapshot.queryParams['search_box'];
            routeHasUppercase = /[A-Z]/.test(decodeURIComponent(activatedRoute.split('?')[0].toString()));
            if (
              !isRouteValid ||
              routeHasUppercase ||
              !!activatedRoute.split('/')[4] ||
              (activatedRoute.split('/')[3] &&
                !this.route.snapshot.queryParams['date'] &&
                !this.route.snapshot.queryParams['utm_source'] &&
                !this.route.snapshot.queryParams['refer'])
            ) {
              if (!activatedRoute.toLocaleLowerCase().includes('ecolodge')) {
                let a = this.document.createElement('div');
                a.innerHTML = 'unfortunately no content is found';
                a.className = 'hidden-custom';
                this.document.body.appendChild(a);
                this.transferState.set(
                  this.routeValidation,
                  !isRouteValid ||
                  routeHasUppercase ||
                  !!activatedRoute.split('/')[4] ||
                  (activatedRoute.split('/')[3] &&
                    !this.route.snapshot.queryParams['date'] &&
                    !this.route.snapshot.queryParams['utm_source'] &&
                    !this.route.snapshot.queryParams['refer'])
                );
              }
            }
          }
        }),
        // retry({
        //   count: 3,
        //   delay: (_, retryCount) => timer(retryCount * 500)
        // }),
        catchError((err) => {
          // console.warn('Error catched with our custom GlobalHTTPInterceptor', err)
          if (err.status === 0) {
            // this.notif.error('CORS Error','ارور خوردیم. بکند کورس میده',5000);
          }
          if (err.status === 500) {
            // this.notif.error('خطای ناشناخته','متاسفانه در ارتباط با سرور اختلالی پیش اومده. لطفا یکم بعد دوباره امتحان کنید !',5000);
          }
          if (err.status === 404) {
            let a = this.document.createElement('div');
            a.innerHTML = 'unfortunately no content is found';
            a.className = 'hidden-custom';
            this.document.body.appendChild(a);
          }
          if (err.status === 400) {
            let a = this.document.createElement('div');
            a.innerHTML = 'unfortunately no content is found';
            a.className = 'hidden-custom';
            this.document.body.appendChild(a);
            this.router.navigate(['notfound']);
          }
          throw err;
        })
      );
    } else {
      return next.handle(request).pipe(
        takeUntilDestroyed(),
        tap((response) => {
          if (
            this.transferState.get(this.routeValidation, false) &&
            !this.router.routerState.snapshot.url.toLocaleLowerCase().includes('ecolodge')
          ) {
            this.router.navigate(['notfound']);
          }
        }),


        catchError((err) => {
          if (err.status === 404) {

            console.error('404 - Page Not Found');
            let mainElement = this.document.querySelector('main');
            if (mainElement) {
              mainElement.innerHTML = `
       <div class="container">
          <div class="w-full flex justify-center my-10 flex-col text-center items-center">
            <img src="https://www.iranhotelonline.com/content/assets/images/error404.svg" alt="404 page error"
              class="lg:w-[748px] w-full lg:h-[333px] object-contain">
            <h3 class="mt-5">صفحه مورد نظر یافت نشد:(</h3>
              <a href="/" class="text-blue-500">
            بازگشت به صفحه اصلی
            </a>
          </div>
        </div>
      `;
            }
          }
          if (err.status === 400 && (err.url.includes('getHotelSummaryInfo') ||
            err.url.includes('search/filter') ||
            err.url.includes('GetAllSections'))
          ) {
            console.error('400 - Bad Request');
            let errText = `متاسفانه در ارتباط با سرور اختلالی پیش اومده.<br /> 
            <a href="/" class="text-blue-500">
            بازگشت به صفحه اصلی
            </a>`;
            this.loadingService.showNavigation(errText);

          }

          throw err;
        })

      );
    }
  }
}
